import { AppThunk } from '../../../store/rootReducer';
import * as waveActions from '../actions/wave.actions';
import {
  selectedIdsSelector,
  selectedWavesSelector,
} from '../selectors/wave.selectors';
import { TagLabel } from '../types/tag.type';
import { WaveId, WaveType } from '../types/wave.type';

export const setWavesTags =
  (tags: TagLabel[], waveId: WaveId, waveType: WaveType): AppThunk =>
  async (dispatch, getState) => {
    const selectedWaves = selectedWavesSelector(getState());

    const isOfSameType = selectedWaves.every(({ type }) => type === waveType);

    if (!isOfSameType) {
      dispatch(waveActions.unselectAll({ meta: { history: false } }));
    }
    const waveIds = selectedIdsSelector(getState());
    const selectedIds = waveIds.length > 0 ? waveIds : [waveId];
    dispatch(waveActions.setTags({ waveIds: selectedIds, tags }));
  };
